import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Button, message, Input, Form, Select, Checkbox } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import { GetPosp } from "../../Redux/actions/NumBikeation";
import { ONBLogin } from "../../Redux/actions/OnboardAction";
import "./onboard.css";
function VerifyOtp() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const RemPass = useSelector((state) => state?.pass);
  const OTPData = useSelector((state) => state?.posp?.onboardOtp);

  const [LogDetail, setLogDetail] = useState(RemPass);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [iserror, setiserror] = useState(false);
  const [loading, setloading] = useState(false);
  //   const [rememberPassword, setRememberPassword] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");

  const history = useHistory();
  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);

  const prefixSelector = (
    <Select
      style={{
        width: 70,
      }}
      defaultValue="+91"
    >
      <Option value="+91">+91</Option>
    </Select>
  );
  const handleSubmit = (values) => {
    console.log(values);
    console.log(BaseUrl);
    let post = {
      phonenumber: OTPData?.phone,
      otp: values?.otp,
    };
    setloading(true);
    axios
      .post(`${BaseUrl}v1/posp/otp/verify`, post)
      .then((res) => {
        console.log(res);
        const Udata = res?.data;
        console.log(Udata);
        setloading(false);
        dispatch(GetPosp(Udata));
        dispatch(ONBLogin(Udata));
        // dispatch({ type: "RESET_CAR" });
        // dispatch({ type: "RESET_BIKE" });
        history.push("/profileDetails");
      })
      .catch((err) => {
        console.log(err.response);
        if (err?.response?.data?.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
        setloading(false);
        message.error("Invalid credentials!");
      });
  };

  return (
    <>
      <div className="right-section-on col-xl-5 col-lg-6 col-md-6">
        <div className="login-container-onboard">
          <div className="d-block text-center my-2">
            <h4 className="mb-2" style={{ color: "#00000069" }}>
              Verify Your Mobile Number
            </h4>
            <p>We Have Sent Otp to - {OTPData?.phone}</p>
          </div>
          <Form
            onFinish={handleSubmit}
            form={form}
            //requiredMark={false}
            layout="vertical"
          >
            <Form.Item
              label="Enter Otp"
              name="otp"
              rules={[{ required: true, message: "Enter Otp" }]}
            >
              <Input
                maxLength={10}
                //addonBefore={prefixSelector}
                placeholder="Enter OTP"
              ></Input>
            </Form.Item>
            <Form.Item className="mb-2">
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: "100%",
                  background: "#293890",
                  border: "#293890",
                  marginTop: "3%",
                  maxHeight: "42px",
                  minHeight: "42px",
                }}
                loading={loading}
              >
                Verify OTP
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
}

export { VerifyOtp };
